/** @jsx jsx */
import { jsx } from '@emotion/react';

import DomainV2RootContent from 'bundles/browse/v2/components/DomainV2RootContent';
import DomainV2Provider from 'bundles/browse/v2/providers/DomainV2Provider';

const DomainV2Page = () => {
  return (
    <DomainV2Provider>
      <DomainV2RootContent />
    </DomainV2Provider>
  );
};

export default DomainV2Page;
